import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { SeasonService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { Season } from '../../models'

const log = new Logger('SeasonDetailResolver')
@Injectable({ providedIn: 'root' })
export class SeasonDetailResolver implements Resolve<Observable<Season>> {
  constructor(private seasonService: SeasonService, private router: Router) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['sid']
    
    return this.seasonService.getDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/admin/season']))
    )
  }
}
